import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import { List } from 'immutable';
import { LoadingPane, ModalWindow, ConfirmModalWindow, SaveButton, formElements } from '../common';
import { tenantHelpers } from '../tenantInfo';
import { TouchpointPermissionsComponent, siteListActions, touchpointListActions, programListActions, touchpointSettingsActions } from './touchpoint';
import * as demographicsActions from './demographics/demographics.actions';
import * as permissionsActions from './permissions.actions';
import { Title } from '../layout';

export const demographicsModalOptions = [
  { id: 0, value: "yes", label: "Yes, take me to Demographics permissions first" },
  { id: 1, value: "no", label: "No, make Demographics available now" },
  { id: 2, value: "cancel", label: "Cancel" }
];
export const defaultDemographicsModalSelection = demographicsModalOptions[0].value;
export const demographicsCheckboxValue = "enabled-status";
export const demographicsCheckboxOptions = [
  { id: "checkboxDemoEnabled", value: demographicsCheckboxValue, label: "Let participants view and/or edit their Demographics" }
];

export class PermissionsComponent extends Component {

  componentDidMount() {
    const { demographicsActions, siteListActions } = this.props;
    siteListActions.fetchSiteList();
    demographicsActions.fetchSettings();
  }

  componentWillUpdate(nextProps, nextState) {
    const { demographicsActions, siteListActions } = this.props;
    siteListActions.fetchSiteList();
    demographicsActions.fetchSettings();
  }

  componentDidUpdate(prevProps, prevState) {
    const { permissions : prevPermissionsState } = prevProps;
    const { showEnableDemographicsModal : enableWasShowing, showDisableDemographicsModal : disableWasShowing } = prevPermissionsState || {};
    const { permissions } = this.props;
    const { showEnableDemographicsModal : enableIsShowing, showDisableDemographicsModal : disableIsShowing } = permissions || {};

    var enableModalContent = document.getElementById('enable-demo-modal-content');
    var disableModalContent = document.getElementById('disable-demo-modal-content');
    var mainView = document.getElementById('view');
    if(enableIsShowing && !enableWasShowing) {
      if(enableModalContent) enableModalContent.focus();
    }
    else if(disableIsShowing && !disableWasShowing) {
      if(disableModalContent) disableModalContent.focus();
    }
    else if((!enableIsShowing && enableWasShowing) || (!disableIsShowing && disableWasShowing)) {
      if(mainView) mainView.focus();
    }
  }

  /**
   * Handle what happens when user selects/deselects participant demographics checkbox
   */
  handleDemographicsPermissionsChange() {
    const { permissionsActions } = this.props;
    const { openDisableDemographicsModal, openEnableDemographicsModal, updateDemographicsCheckbox } = permissionsActions || {};

    return(value) => {
      var checked = !!value && value.includes(demographicsCheckboxValue);
      updateDemographicsCheckbox(checked);
      if(checked === true){
        openEnableDemographicsModal();
      } else {
        openDisableDemographicsModal();
      }
    }
  }

  handleUpdateModalOption(value) {
    const { permissionsActions } = this.props;
    const { updateModalOption } = permissionsActions;
    const modalOption = !!value && value.size > 0 ? value.get(0) : undefined;
    updateModalOption(modalOption);
  }

  /**
   * Handle result of the modal, presented to the user when they select "Let participants view/edit demographics"
   * @param {string} result : yes - transfer admin to permissions page, no - immediately set availability, cancel
   */
  onConfirmEnableDemographicsModal(result) {
    const { permissionsActions, redirectTo } = this.props;
    const { submitDemographicsEnabledStatus, updateDemographicsCheckbox, closeEnableDemographicsModal, updateModalOption } = permissionsActions;

    switch (result) {
      case 'yes':
        updateDemographicsCheckbox(false);
        redirectTo("/permissions/demographics");
        break;
      case 'no':
        submitDemographicsEnabledStatus(true)
        .then(res => {
          toastr.success('Success', 'Demographics enabled for participants');
        })
        .catch(err => {
          toastr.error(err.errorCode, err.errorMessage);
        });
        break;
      case 'cancel':
      default:
        updateDemographicsCheckbox(false);
        break;
    }

    closeEnableDemographicsModal();
    updateModalOption(defaultDemographicsModalSelection);
  }

  onConfirmDisableDemographicsModal(e, result) {
    const { permissionsActions } = this.props;
    const { updateDemographicsCheckbox, closeDisableDemographicsModal, submitDemographicsEnabledStatus } = permissionsActions;

    if(!!result) {
      updateDemographicsCheckbox(false);
      submitDemographicsEnabledStatus(false)
        .then(res => {
          toastr.success('Success', 'Demographics disabled for participants');
        })
        .catch(err => {
          toastr.error(err.errorCode, err.errorMessage);
        });
    } else {
      updateDemographicsCheckbox(true);
    }

    closeDisableDemographicsModal();
  }

  render() {
    const { sites, siteListActions, forms, touchpointListActions, programs, programListActions, permissions, permissionsActions, formSettings,
      touchpointSettingsActions, redirectTo, demographics } = this.props;
    const { selectedSiteId, pagingData : sitePaging, siteListState } = sites || {};
    const { sortBy : siteSortBy, sortAsc : siteSortAsc, itemsPerPage : sitesPerPage } = sitePaging || {};
    const { isFetching : sitesLoading, err : siteErr, data : siteList } = siteListState || {};
    const { formLists, allForms } = forms || {};
    const formsState = formLists && formLists.get(selectedSiteId);
    const { sortBy : formSortBy, sortAsc: formSortAsc, itemsPerPage : formsPerPage, formListState, formsEditData } = formsState || {};
    const { isFetching : formsLoading, err : formErr, formList } = formListState || { isFetching: false };
    const { permissionsData, permissionsSubmission, permissionsResponse, showEnableDemographicsModal,
      showDisableDemographicsModal, modalSelectedOption, demographicsCheckboxSelected } = permissions || {};
    const sitePermissions = permissionsData && permissionsData.get(selectedSiteId);
    const sitePermissionsSubmission = permissionsSubmission && permissionsSubmission.get(selectedSiteId);
    const sitePermissionsResponses = permissionsResponse && permissionsResponse.get(selectedSiteId);
    const { settings, settingsResponses, settingsSubmission } = formSettings || {};
    const { settings: demographicsSettings } = demographics || {};
    const { data: demographicsData, isFetching: demographicsFetching } = demographicsSettings || {};
    const { demographicsEnabled } = demographicsData || false;

    const touchpointPermissionProps = {
      siteListProps: {
        isFetching : sitesLoading,
        err : siteErr,
        selectedSiteId,
        sites : siteList,
        sortBy : siteSortBy,
        sortAsc : siteSortAsc,
        resultsPerPage: sitesPerPage,
        ...siteListActions
      },
      touchpointListProps: {
        isFetching : formsLoading,
        err: formErr,
        forms : formList,
        formsEditData,
        allForms,
        sortBy : formSortBy,
        sortAsc : formSortAsc,
        resultsPerPage: formsPerPage,
        settings,
        settingsResponses,
        settingsSubmission,
        ...touchpointSettingsActions,
        ...touchpointListActions,
        permissionProps: {
          permissions: sitePermissions,
          submission: sitePermissionsSubmission,
          responses: sitePermissionsResponses,
          ...permissionsActions,
        },
        programData: programs,
        programListActions,
      }
    }

    const enableDemoModal =
      <ModalWindow
        modalId="enable-demo-modal"
        contentId="enable-demo-modal-content"
        show={showEnableDemographicsModal}
        title={"Enable Demographics"}
        onClose={e => this.onConfirmEnableDemographicsModal('cancel') }
        children={(
          <div className="form-horizontal survey">
            <p>If you select this check box, Demographics will be available to {tenantHelpers.getProductName()} users immediately.</p>
            <p>Do you want to review Demographics permissions before making them available?</p>
            <p className="modal-indent">
              <formElements.RadioElement
                id='modal-radio-element'
                options={List(demographicsModalOptions)}
                onChange={(value) => this.handleUpdateModalOption(value)}
                defaultValue={List([defaultDemographicsModalSelection])}
                response={!!modalSelectedOption ? List([modalSelectedOption]) : undefined}
                isRequired={false}
                css={{ buttonLabel: 'save-list', radioButton: 'save-list', label: 'save-list' }} />
            </p>
          </div>
        )}
        footer={(
          <div className="actions">
            <SaveButton
              id="modal-save"
              text={"OK"}
              onSave={e => this.onConfirmEnableDemographicsModal(
                !!modalSelectedOption ? modalSelectedOption : defaultDemographicsModalSelection)}/>
          </div>
        )}>
      </ModalWindow>;

    const disableDemoModal =
      <ConfirmModalWindow
        modalId="disable-demo-modal"
        contentId="disable-demo-modal-content"
        show={showDisableDemographicsModal}
        title={`Removing Demographics from ${tenantHelpers.getProductName()}`}
        onClose={(e, result) => this.onConfirmDisableDemographicsModal(e, result) }>
        <div className="form-horizontal survey">
          <p>Are you sure you want to remove Demographics from {tenantHelpers.getProductName()}?
            Participants will no longer be able to view or edit any personal information.</p>
        </div>
      </ConfirmModalWindow>

    return (
      <div>
        <Title title="Participant Permissions"/>
        {enableDemoModal}
        {disableDemoModal}
        <br/>
        <div className="widget">
          <h3 className="widget-title">Demographics Permissions</h3>
          <LoadingPane id="demographics-settings-loader" isLoading={demographicsFetching}>
            <br/>
            <div className="standard-text">
              <formElements.CheckboxElement
                id="enable-demographics"
                label={""}
                isRequired={false}
                options={List(demographicsCheckboxOptions)}
                onChange={this.handleDemographicsPermissionsChange()}
                defaultValue={demographicsEnabled ? List([demographicsCheckboxValue]) : undefined}
                response={demographicsCheckboxSelected === null ? undefined : demographicsCheckboxSelected ? List([demographicsCheckboxValue]) : List([])}
                css={{buttonLabel: 'standard-text'}}
                />
              </div>
          </LoadingPane>
          <button className="btn btn-primary" onClick={() => redirectTo("/permissions/demographics")}>
            Update Demographics Permissions
          </button>
        </div>
        <div className="widget">
          <h3 className="widget-title">TouchPoint Response Permissions</h3>
          <TouchpointPermissionsComponent {...touchpointPermissionProps}/>
        </div>
      </div>
    );
  }
}

PermissionsComponent.propTypes = {
  demographics: PropTypes.object,
  demographicsActions: PropTypes.object,
  sites: PropTypes.any.isRequired,
  siteListActions: PropTypes.any.isRequired,
  forms: PropTypes.any.isRequired,
  touchpointListActions: PropTypes.any.isRequired,
  programs: PropTypes.any.isRequired,
  programListActions: PropTypes.any.isRequired,
  permissions: PropTypes.any.isRequired,
  permissionsActions: PropTypes.any.isRequired,
  formSettings: PropTypes.any.isRequired,
  touchpointSettingsActions: PropTypes.any.isRequired,
};

const mapStateToProps = ({ sites, forms, programs, permissions, formSettings, demographics }) => {
  return {
    sites,
    forms,
    programs,
    permissions,
    formSettings,
    demographics
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    demographicsActions: bindActionCreators(demographicsActions, dispatch),
    siteListActions: bindActionCreators(siteListActions, dispatch),
    touchpointListActions: bindActionCreators(touchpointListActions, dispatch),
    programListActions: bindActionCreators(programListActions, dispatch),
    permissionsActions: bindActionCreators(permissionsActions, dispatch),
    touchpointSettingsActions: bindActionCreators(touchpointSettingsActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsComponent);
